import { gracely } from "gracely"
import { rest } from "cloudly-rest"
import { Expense } from "./Expense"
import { Receipt } from "./Receipt"

export class Report extends rest.Collection<gracely.Error> {
	readonly expense = new Expense(this.client)
	readonly receipt = new Receipt(this.client)
}
